export default "__VITE_ASSET__F4NXXC2H__"